import useFeatureFlag from "../../../graphql/hooks/useFeatureFlag";

export const useFlexIntakeEnabled = () => {
  return useFeatureFlag("ai_interviewer:flex_intake");
};
